import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTool, FiTruck, FiHome } = FiIcons;

const industries = [
  {
    icon: FiHome,
    title: 'Home Services',
    description:
      'HVAC, plumbing, electrical, roofing, and restoration companies lose booked jobs every time the office misses a call. AI catches those calls, captures the job details, and sends them to dispatch — or auto-forwards the caller directly to your team.',
    stat: '$500–$2,000+ per missed emergency job',
  },
  {
    icon: FiTruck,
    title: 'Auto Dealerships',
    description:
      'Service departments miss 25–38% of inbound calls. Each missed service call costs roughly $270 in lost revenue. AI answers, books the appointment, and routes sales inquiries to the right department — 24/7.',
    stat: '$850K–$1.17M in annual lost service revenue per dealership',
  },
  {
    icon: FiTool,
    title: 'Real Estate Teams',
    description:
      '40–46% of incoming calls to real estate teams go unanswered. Every missed call could be an $8K–$15K commission. AI qualifies the lead, captures property interest, and books showings automatically.',
    stat: "70% drop in conversion when leads aren't responded to immediately",
  },
];

const Industries = () => (
  <section className="py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Industries We Serve</h2>
        <p className="text-lg text-slate-600">Built for businesses that lose revenue every time the phone goes unanswered.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-8">
        {industries.map((industry, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="bg-white rounded-2xl p-8 border border-slate-100 hover:border-green-200 hover:shadow-lg transition-all duration-300 group"
          >
            <div className="w-14 h-14 bg-slate-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-green-50 transition-colors">
              <SafeIcon icon={industry.icon} className="w-7 h-7 text-slate-700 group-hover:text-green-700 transition-colors" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">{industry.title}</h3>
            <p className="text-slate-600 text-sm leading-relaxed mb-6">{industry.description}</p>
            <div className="inline-block px-3 py-1 bg-slate-100 rounded text-xs font-bold text-slate-600">
              {industry.stat}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Industries;